var map = {
	"./cancel_full_screen.svg": 6034,
	"./error.svg": 1411,
	"./full_screen.svg": 4377,
	"./functional.svg": 6638,
	"./home.svg": 7007,
	"./lang.svg": 8085,
	"./login.svg": 9934,
	"./menu.svg": 6777,
	"./modular.svg": 5117,
	"./system.svg": 7907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2726;